var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1Travel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 28v26a4 4 0 01-4 4h-3V24h3a4 4 0 014 4zm-16-4v-6a4 4 0 00-4-4H31a4 4 0 00-4 4v6h-5v34h32V24h-5zM38.51 51.06l-3.75-6.5 9.74-5.62 3.75 6.49-9.74 5.63zM31 24v-6h14v6H31zm-16 0a4 4 0 00-4 4v26a4 4 0 004 4h3V24h-3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Travel.9cf7373b.svg";
export { SvgF1Travel as ReactComponent };